import { useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

function ThemeCssVars() {
    const theme = useTheme();

    useEffect(() => {
        const root = document.documentElement;
        
        // set CSS variables based on current theme
        root.style.setProperty('--mui-palette-mode', theme.palette.mode);
        root.style.setProperty('--mui-palette-primary-main', theme.palette.primary.main);
        root.style.setProperty('--mui-palette-secondary-main', theme.palette.secondary.main);
        root.style.setProperty('--mui-palette-error-main', theme.palette.error.main);
        root.style.setProperty('--mui-palette-warning-main', theme.palette.warning.main);
        root.style.setProperty('--mui-palette-info-main', theme.palette.info.main);
        root.style.setProperty('--mui-palette-success-main', theme.palette.success.main);
        root.style.setProperty('--mui-palette-background-default', theme.palette.background.default);
        root.style.setProperty('--mui-palette-background-paper', theme.palette.background.paper);
        root.style.setProperty('--mui-palette-text-primary', theme.palette.text.primary);
        root.style.setProperty('--mui-palette-text-secondary', theme.palette.text.secondary);
        root.style.setProperty('--mui-palette-divider', theme.palette.divider);
        root.style.setProperty('--mui-palette-action-hover', theme.palette.action.hover);
        root.style.setProperty('--mui-palette-action-selected', theme.palette.action.selected);
        root.style.setProperty('--mui-palette-action-disabled', theme.palette.action.disabled);
        root.style.setProperty('--mui-palette-action-disabledBackground', theme.palette.action.disabledBackground);
    }, [theme]);

    return null;
}

export default ThemeCssVars;

